'use client';

import { useTranslation } from '@/i18n/client';
import axios from 'axios';
import { useParams } from 'next/navigation';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Button, Carousel, Col, Container, Row } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { Locale } from '../../../../i18n-config';
import Contexts from '@/contexts';
import { useMediaQuery } from '@uidotdev/usehooks';
import Section3 from '../home/Section3';
import Section14 from '../home/Section14';
import { BsFacebook, BsInstagram, BsLinkedin, BsYoutube } from 'react-icons/bs';
import { FaTripadvisor } from 'react-icons/fa';
import Image from 'next/image';

// import "react-widgets/dist/css/react-widgets.css";
// import "../../assets/style/scss/guestbook.scss";

const styles = {
  div: {
    border: '1px solid #e0dede',
    borderRadius: '20px',
  },
  div_clicked: {
    border: '1px solid #e0dede',
    borderRadius: '20px',
    backgroundColor: '#e0dede',
  },
  link: { color: 'black', fontSize: '30px' },
};

const Client = (props) => {
  const { lang } = useParams();
  const { t } = useTranslation(lang as Locale);

  const generalData = useContext(Contexts.sharedDataContext);

  const isMobile = useMediaQuery('only screen and (max-width : 768px)');

  // const [choose, setChoose] = useState(
  //   props.location.param1 ? props.location.param1 : Math.floor(Math.random() * 18) + 1
  // );

  const [all_guest_book, setAllGuestBook] = useState([]);

  useEffect(() => {
    axios.get('https://api.iranjourney.com/api/contact/feedback/list_create').then((res) => {
      setAllGuestBook(res.data.results);
    });
  }, []);

  const [selectedItem, setSelectedItem] = useState('');

  const [generalPageData, setGeneralPageData] = useState<any>({});

  const [targetCountry, setTargetCountry] = useState<any>({});

  const [travelerId, setTravelerId] = useState<number | undefined>();

  const guestBookConfigs = useQuery(
    'guest-book-configs',
    () => fetch('https://api.iranjourney.com/api/pageconfig/guest_book_config').then((res) => res.json()),
    {
      onSuccess: (data) => {
        setGeneralPageData(data[0]);
      },
    }
  );

  const listAvailableCountries = useQuery(
    'guest-book-list-countries',
    () => fetch('https://api.iranjourney.com/api/pageconfig/list_nationality_has_guestbook').then((res) => res.json()),
    {
      onSuccess: (data) => {
        setTravelerId(undefined);
        setTargetCountry(data[0].name);
      },
    }
  );

  const countryBaseUserReview = useQuery(
    'guest-book-country-base-reviews',
    () => fetch('https://api.iranjourney.com/api/pageconfig/guestbooks_categorized/').then((res) => res.json()),
    {
      onSuccess: (data) => {
        setTravelerId(data[targetCountry]?.guestbooks[0].id);
      },
    }
  );

  const travelerReview = useQuery(
    `guest-book-reviewer-comments-${travelerId}`,
    () => fetch(`https://api.iranjourney.com/api/pageconfig/guestbook_details/${travelerId}`).then((res) => res.json()),
    {
      enabled: !!travelerId,
    }
  );

  return (
    <div className="tw-mt-[66px]">
      <Carousel>
        <Carousel.Item>
          <img className="d-block w-100" src={generalPageData?.banner_1500_1} alt={generalPageData?.title_1} />
          <Carousel.Caption
            style={{
              backgroundColor: 'rgba(0,0,0,0.5)',
              bottom: '40%',
              textAlign: 'left',
              maxWidth: '350px',
              padding: '10px',
            }}
          >
            <h3>{generalPageData?.title_1}</h3>
            <p>{generalPageData?.text_1}</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={generalPageData?.banner_1500_2} alt={generalPageData?.title_2} />
          <Carousel.Caption
            style={{
              backgroundColor: 'rgba(0,0,0,0.5)',
              bottom: '40%',
              textAlign: 'left',
              maxWidth: '350px',
              padding: '10px',
            }}
          >
            <h3>{generalPageData?.title_2}</h3>
            <p>{generalPageData?.text_2}</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={generalPageData?.banner_1500_3} alt={generalPageData?.title_3} />
          <Carousel.Caption
            style={{
              backgroundColor: 'rgba(0,0,0,0.5)',
              bottom: '40%',
              textAlign: 'left',
              maxWidth: '350px',
              padding: '10px',
            }}
          >
            <h3>{generalPageData?.title_3}</h3>
            <p>{generalPageData?.text_3}</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>

      <Container>
        <div className="pt-4 pb-3">
          <h1 className="text-center mb-3">{generalPageData?.main_title_latin}</h1>
          <p className="h5" style={{ fontWeight: 'normal' }}>
            {generalPageData?.main_text_latin}
          </p>
        </div>

        <div>
          <ul className="list-unstyled d-flex align-items-center p-0 mb-0 justify-content-center" style={{ gap: 10 }}>
            <li>
              <a style={styles.link} href={generalData.facebook_url} target="_blank" aria-label="Facebook">
                {' '}
                <BsFacebook size={22} />
              </a>
            </li>
            <li>
              <a style={styles.link} href={generalData.linkedin_url} target="_blank" aria-label="Linkedin">
                {' '}
                <BsLinkedin size={22} />
              </a>
            </li>
            <li>
              <a style={styles.link} href={generalData.instagram_url} target="_blank" aria-label="Instagram">
                <BsInstagram size={22} />
              </a>
            </li>
            <li>
              <a style={styles.link} href={generalData.youtube_url} target="_blank" aria-label="YouTube">
                <BsYoutube size={22} />
              </a>
            </li>
            <li>
              <a style={styles.link} href={generalData.tripadvisor_url} target="_blank" aria-label="Trip advisor">
                <FaTripadvisor size={22} />
              </a>
            </li>
          </ul>
        </div>

        {generalPageData?.video_url && (
          <Container>
            <video src={generalPageData?.video_url}>Video not supported</video>
          </Container>
        )}

        <h3 className="text-center mt-4 text-black-50">{t('Reviews')}</h3>

        <div className="countries-list">
          {listAvailableCountries.isLoading ? (
            <p>Loading...</p>
          ) : listAvailableCountries.isError ? (
            <p>
              Failed to load data <Button onClick={() => listAvailableCountries?.refetch()}>Reload</Button>
            </p>
          ) : (
            <div className="mt-5">
              <h4 className="text-center">Select a flag to see the reviews</h4>

              <ul
                className="list-unstyled p-0 my-3 d-flex flex-wrap align-items-center justify-content-center"
                style={{ gap: 10 }}
              >
                {listAvailableCountries.isSuccess &&
                  Object.values(
                    listAvailableCountries.data.reduce((a, c) => {
                      a[c.name + '|' + c.flag] = c;
                      return a;
                    }, {})
                  ).map((country: any, index) => (
                    <li
                      key={index}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setTravelerId(undefined);
                        setTargetCountry(country.name);
                      }}
                    >
                      <img src={country.flag} alt={country.name} width={100} height={100} className="img-fluid" />
                    </li>
                  ))}
              </ul>

              <hr />
            </div>
          )}
        </div>

        <div className="country-base-reviewers">
          {countryBaseUserReview.isLoading ? (
            <p>Loading...</p>
          ) : countryBaseUserReview.isError ? (
            <p>
              Failed to load data <Button onClick={() => countryBaseUserReview.refetch()}>Reload</Button>
            </p>
          ) : (
            <div>
              <h4 className="text-center mb-4">Select a card to read full text</h4>

              <Row className="justify-content-center my-2">
                {countryBaseUserReview.data[targetCountry]?.guestbooks?.map((guest, index) => (
                  <Col sm={4} md={4} xs={12} key={index} className="mb-3">
                    <div
                      className="d-flex align-items-start bg-white p-3 w-100"
                      style={{
                        borderRadius: 10,
                        cursor: 'pointer',
                        border: travelerId === guest.id ? '2px solid #521232' : '2px solid transparent',
                      }}
                      onClick={() => setTravelerId(guest.id)}
                    >
                      <img
                        src={guest.photograph}
                        alt={guest.guest_name}
                        className="img-fluid me-3 rounded-circle"
                        width={100}
                        height={100}
                      />
                      <div className="d-flex flex-column w-100" style={{ minHeight: 100 }}>
                        <h5 className="text-black-50 mb-0 mt-0">{guest.guest_name}</h5>
                        <img
                          src={countryBaseUserReview.data[targetCountry].flag}
                          alt={targetCountry}
                          width={70}
                          height={50}
                          className="img-fluid ml-auto mt-auto"
                        />
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
              <hr />
            </div>
          )}
        </div>

        {travelerReview.isLoading ? (
          <p>Loading...</p>
        ) : travelerReview.isError ? (
          <p>
            Failed to load data <Button onClick={() => travelerReview?.refetch()}>Reload</Button>
          </p>
        ) : (
          <>
            {travelerId && (
              <div className="tw-h-full">
                <div className="reviewer-comment d-flex">
                  <img
                    src={travelerReview?.data && travelerReview?.data[0] && travelerReview?.data[0]?.photograph}
                    className="img-fluid rounded-circle me-3"
                    width={120}
                    height={120}
                    style={{ maxHeight: 120 }}
                  />
                  <div className="tw-mb-[50px] tw-h-full">
                    {travelerReview?.data && travelerReview?.data[0] && travelerReview?.data[0]?.guest_name && (
                      <h5>{travelerReview?.data && travelerReview?.data[0] && travelerReview?.data[0]?.guest_name}</h5>
                    )}
                    {travelerReview?.data && travelerReview?.data[0] && travelerReview?.data[0]?.text && (
                      <>
                        {travelerReview?.data &&
                          travelerReview?.data[0] &&
                          travelerReview?.data[0]?.text.split('\r').map((paragraph, index) => (
                            <p key={index} className="mb-1">
                              {paragraph}
                            </p>
                          ))}
                      </>
                    )}

                    <b>Visited: {travelerReview?.data && travelerReview?.data[0] && travelerReview?.data[0]?.date}</b>

                    {travelerReview.data && travelerReview.data[0] && travelerReview.data[0].guest_book_image && (
                      <Image
                        src={travelerReview.data[0].guest_book_image}
                        alt=""
                        sizes="100vw"
                        width={500}
                        height={500}
                        className="tw-w-full tw-h-full tw-my-4"
                      />
                    )}
                  </div>
                </div>

                {travelerReview?.data && travelerReview?.data[0] && travelerReview?.data[0]?.guest_book && (
                  <div className="text-center my-4">
                    <img src={travelerReview?.data[0]?.guest_book} className="img-fluid w-75" />
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </Container>

      <div className="tw-mb-10">
        <Section3 />
      </div>

      <div className="mb-3">
        <Section14 />
      </div>
    </div>
  );
};

export default Client;
